import { css } from '@emotion/core';

export const V5Styles = css`
  @font-face {
    font-family: Geograph;
    src: url('https://zapier-fonts-production.s3.amazonaws.com/Geograph/geograph-regular.woff2')
      format('woff2');
    font-display: swap;
    font-weight: 400;
  }

  @font-face {
    font-family: Geograph;
    src: url('https://zapier-fonts-production.s3.amazonaws.com/Geograph/geograph-medium.woff2')
      format('woff2');
    font-display: swap;
    font-weight: 500;
  }

  @font-face {
    font-family: Geograph;
    src: url('https://zapier-fonts-production.s3.amazonaws.com/Geograph/geograph-bold.woff2')
      format('woff2');
    font-display: swap;
    font-weight: 700;
  }

  :root {
    // Brand colors
    --zds-colors-zapier: #ff4f00;
    --zds-colors-moss: #1a4a4c;
    --zds-colors-night: #2c3266;
    --zds-colors-lavender: #c1b7ff;
    --zds-colors-peach: #ffe7d1;
    --zds-colors-bolt: #fdff9f;
    --zds-colors-sky: #9ddef3;
    --zds-colors-cream: #fff3e6;

    /* Blues */
    --zds-colors-blue-jeans: #3d4592;
    --zds-colors-bluebell: #5e71c7;
    --zds-colors-periwinkle: #90a1ed;
    --zds-colors-lilac: #b2bce9;
    --zds-colors-hydrangea: #d2d8f3;
    --zds-colors-acid-wash: #f0f1fa;

    /* Error */
    --zds-colors-error-500: #b83519;
    --zds-colors-error-400: #ce482d;
    --zds-colors-error-300: #e87057;
    --zds-colors-error-200: #feb7a8;
    --zds-colors-error-100: #fadfd9;

    /* Warning */
    --zds-colors-warning-500: #dfb900;
    --zds-colors-warning-400: #ffd300;
    --zds-colors-warning-300: #f8df68;
    --zds-colors-warning-200: #fcec9f;
    --zds-colors-warning-100: #fff4bc;

    /* Success */
    --zds-colors-success-500: #086f3d;
    --zds-colors-success-400: #0f884e;
    --zds-colors-success-300: #36a770;
    --zds-colors-success-200: #ade2c8;
    --zds-colors-success-100: #def3e9;

    /* Neutrals */
    --zds-colors-neutral-800: #2d2e2e;
    --zds-colors-neutral-700: #403f3e;
    --zds-colors-neutral-600: #95928e;
    --zds-colors-neutral-500: #a8a5a0;
    --zds-colors-neutral-400: #d7d5d2;
    --zds-colors-neutral-300: #e8e7e4;
    --zds-colors-neutral-200: #f7f5f2;
    --zds-colors-neutral-100: #fffdf9;

    /* Typography */
    --zds-typography-base: 'Inter', sans-serif;
    --zds-typography-heading: 'Geograph', sans-serif;
    --zds-typography-letter-spacing: -0.5px;
    --zds-typography-pageheader-weight: 500;
    --zds-typography-pageheader1-fontsize: 72px;
    --zds-typography-pageheader1-lineheight: 76px;
    --zds-typography-pageheader3-fontsize: 56px;
    --zds-typography-pageheader3-lineheight: 64px;
    --zds-typography-pageheader5-lineheight: 48px;
    --zds-typography-pageheader7-lineheight: 40px;
    --zds-typography-pageheader9-lineheight: 32px;
    --zds-typography-paragraph1short-lineheight: 24px;
    --zds-typography-paragraph3-lineheight: 24px;
  }
`;
